import React, { forwardRef, useImperativeHandle } from 'react';
// import Application from '../pdf/Application.pdf';
// import Application from '../pdf/ApplicationForm.pdf'
import Application from '../pdf/Application_Form.pdf'
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import icon from '../All/images/tick-icon.png';
// import icon from '../All/images/tick-icon.png';

import { removeBracketedText } from '../Axiosinstance';

const ApplicationForm = forwardRef((dataProp, ref) => {

    const handleDownload = async (studentdetails) => {
        console.log("studentdetails:", studentdetails)
        try {
            const pdfBytes = await fetch(Application).then(res => res.arrayBuffer());
            const pdfDoc = await PDFDocument.load(pdfBytes);




            // Access the pages
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const secondPage = pages[1];

            // Set font and size
            const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);
            const fontSize = 10;



            // Data to insert
            const studentName = (studentdetails?.name || '').toUpperCase();
            const passportNo = studentdetails?.passport || '';
            const passportexpire = studentdetails?.passportExpiryDate || '';
            const nric = studentdetails?.nric || '';
            const handphone = studentdetails?.phone || '';
            const officephone = studentdetails?.officephone || '';
            const email = studentdetails?.email || '';
            const dob = studentdetails?.dob || '';
            const citizenship = (studentdetails?.citizenship || '').toUpperCase();
            const durationType = studentdetails?.durationType || '';
            const religion = (studentdetails?.religion || '').toUpperCase();
            const gender = (studentdetails?.gender || '').toUpperCase();
            const singapore = (studentdetails?.currentAddress || '').toUpperCase();
            // const type = (studentdetails?.type || '');
            // const months = type === "diploma" ? 12 : (type === "advance_diploma" ? 6 : 0);
            const months = 12;
            const martialStatus = (studentdetails?.martialStatus || '').toUpperCase();

            const relationship = (studentdetails?.relationship || '').toUpperCase() || "NA";
            const fatherName = (studentdetails?.fatherName || '').toUpperCase() || "NA";
            const fatherphone = (studentdetails?.fatherPhoneNo || '').toUpperCase() || "NA";;
            // const fatherInfo = (father && fatherphone) ? `${father} / ${fatherphone}` : '';
            const brother = (studentdetails?.brotherName || '').toUpperCase();
            const brotherphone = (studentdetails?.brotherPhoneNo || '').toUpperCase();
            // const brotherInfo = (brother && brotherphone) ? `${brother} / ${brotherphone}` : '';
            // const institute = (studentdetails?.fatherName || '').toUpperCase();
            const workExpirences = studentdetails?.workExpirences || '';
            const profileUrl = studentdetails?.profileUrl || '';
            const educationData = studentdetails?.institutionDetails || [];
            const offerDate = studentdetails?.offerDate || [];



            const formatDate = (dateString) => {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            function formatDatepassport(dateString) {
                // Split the input date string
                const [year, month, day] = dateString.split('-');

                // Format to DD/MM/YYYY
                return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
            }

            // const course = (dataProp?.batch?.course || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const course = removeBracketedText((studentdetails?.course || '')).toUpperCase();
            // const intakeId = (dataProp?.intakeId || '').toUpperCase().replace(/\s*\(1\)$/, '');
            const institutionDetails = studentdetails?.institutionDetails || [];

            // Draw existing text on different pages
            firstPage.drawText(studentName, { x: 165, y: 452, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(passportNo, { x: 332, y: 417, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(formatDatepassport(passportexpire), { x: 540, y: 416, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(nric, { x: 145, y: 417, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(formatDate(dob), { x: 144, y: 381, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(religion, { x: 123, y: 346, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(handphone, { x: 140, y: 310, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(`${months} months`, { x: 150, y: 204, size: 10, font, color: rgb(0, 0, 0), });

            firstPage.drawText(email, { x: 345, y: 308, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(citizenship, { x: 320, y: 342, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(course, { x: 173, y: 236, size: 11, font, color: rgb(0, 0, 0), });
            // firstPage.drawText(course, { x: 257, y: 249, size: 10, font, color: rgb(0, 0, 0), });

            if (profileUrl) {
                const imageBytes = await fetch(profileUrl).then(res => res.arrayBuffer());
                const isJpg = profileUrl.endsWith('.jpg') || profileUrl.endsWith('.jpeg');
                const isPng = profileUrl.endsWith('.png');

                let embeddedImage;
                if (isJpg) {
                    embeddedImage = await pdfDoc.embedJpg(imageBytes);
                } else if (isPng) {
                    embeddedImage = await pdfDoc.embedPng(imageBytes);
                }

                firstPage.drawImage(embeddedImage, {
                    x: 630,
                    y: 363,
                    width: 107,
                    height: 134,
                });
            }



            firstPage.drawText(relationship, {
                x: 412,
                y: 120,
                size: 10,
                font,
                color: rgb(0, 0, 0),
            });
            firstPage.drawText(fatherName, {
                x: 115,
                y: 120,
                size: 10,
                font,
                color: rgb(0, 0, 0),
            });
            firstPage.drawText(fatherphone, {
                x: 590,
                y: 120,
                size: 10,
                font,
                color: rgb(0, 0, 0),
            });

            firstPage.drawText(singapore, { x: 166, y: 273, size: 10, font, color: rgb(0, 0, 0), });
            firstPage.drawText(gender, { x: 296, y: 381, size: 10, font, color: rgb(0, 0, 0), });

            firstPage.drawText(martialStatus, { x: 520, y: 381, size: 10, font, color: rgb(0, 0, 0), });

            //FOR LAST page
            const drawWrappedText = (page, text, xFirst, y, maxWidthFirst, xSubsequent, maxWidthSubsequent, font, fontSize, color) => {
                const lines = [];
                let currentLine = '';
                let words = text.split(' ');

                while (words.length > 0) {
                    let word = words.shift();
                    let testLine = currentLine + word + ' ';
                    let testWidth = font.widthOfTextAtSize(testLine, fontSize);

                    if (testWidth <= (lines.length === 0 ? maxWidthFirst : maxWidthSubsequent)) {
                        currentLine = testLine;
                    } else {
                        lines.push(currentLine.trim());
                        currentLine = word + ' ';
                    }
                }
                lines.push(currentLine.trim());

                // Draw lines
                lines.forEach((line, index) => {
                    page.drawText(line, {
                        x: index === 0 ? xFirst : xSubsequent,
                        y: y - (index * fontSize * 3),
                        size: fontSize,
                        font: font,
                        color: color
                    });
                });
            };

            //second page
            secondPage.drawText(studentName, { x: 87, y: 257, size: 10, font, color: rgb(0, 0, 0), });
            secondPage.drawText(formatDate(offerDate), { x: 446, y: 199, size: 10, font, color: rgb(0, 0, 0), });

            // Function to handle text wrapping
            const wrapText = (text, maxWidth) => {
                const words = text.split(" ");
                let lines = [];
                let currentLine = words[0];

                for (let i = 1; i < words.length; i++) {
                    const word = words[i];
                    const width = font.widthOfTextAtSize(`${currentLine} ${word}`, fontSize);

                    if (width < maxWidth) {
                        currentLine += ` ${word}`;
                    } else {
                        lines.push(currentLine);
                        currentLine = word;
                    }
                }
                lines.push(currentLine);
                return lines;
            };


            let startY = 445;
            const rowGap = 20;

            // Slice the last 2 entries
            const lastTwoEntries = educationData.slice(-2);

            lastTwoEntries.forEach(entry => {
                secondPage.drawText(entry.institution || 'NA', {
                    x: 80, // Institution column
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(entry.country || 'NA', {
                    x: 280,
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(entry.fromYear || 'NA', {
                    x: 350, // Year column
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(entry.toYear || 'NA', {
                    x: 410, // Year column
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(entry.qualificationsAchieved || 'NA', {
                    x: 450, // Qualification column
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(entry.educationCertificateNo || 'NA', {
                    x: 630,
                    y: startY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                startY -= rowGap;
            });



            // Work experience section (separate Y)
            let workY = 358;
            const lastWork = workExpirences?.slice(-1)[0];

            if (lastWork) {
                secondPage.drawText(lastWork.name || 'NA', {
                    x: 80,
                    y: workY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });


                secondPage.drawText(lastWork.country || 'NA', {
                    x: 280,
                    y: workY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });


                secondPage.drawText(lastWork.fromYear || 'NA', {
                    x: 347,
                    y: workY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });


                secondPage.drawText(lastWork.toYear || 'NA', {
                    x: 407,
                    y: workY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });

                secondPage.drawText(lastWork.position || 'NA', {
                    x: 460,
                    y: workY,
                    size: 10,
                    font,
                    color: rgb(0, 0, 0),
                });
            }


            // Load and embed the tick icon image
            const tickIconBytes = await fetch(icon).then(res => res.arrayBuffer());
            const tickIconImage = await pdfDoc.embedPng(tickIconBytes);

            // Define scaling factors
            const scaleFirstPage = 0.02; // Scale for the existing tick icons on the first page
            const scaleSixthPage = 0.012; // Scale for the sixth page
            const scaleSeventhPage = 0.014; // Scale for the seventh page
            const separateScaleFirstPage = 0.02; // Scale for the top-right corner tick icon

            // Set scaling factors

            const separateScaledIconFirstPage = tickIconImage.scale(separateScaleFirstPage);

            const { width: separateWidthFirstPage, height: separateHeightFirstPage } = separateScaledIconFirstPage;

            // Draw the separate tick icon in the top-right corner of the first page
            let xKnow, yKnow;

            switch (durationType) {
                case 'part_time':
                    xKnow = 425; // Set the x position for part-time
                    yKnow = 200; // Set the y position for part-time
                    break;
                case 'full_time':
                    xKnow = 350; // Set the x position for full-time
                    yKnow = 200; // Set the y position for full-time
                    break;
                default:
                    xKnow = 160; // Set default x position
                    yKnow = 455; // Set default y position
            }

            firstPage.drawImage(tickIconImage, {
                x: xKnow,
                y: yKnow,
                width: separateWidthFirstPage,
                height: separateHeightFirstPage,
            });




            // Save the modified PDF
            const pdfBytesModified = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };


    const extractDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const toUpperCaseString11 = (dateString) => {
        const date = new Date(dateString);
        const month = getMonthName(date.getMonth());
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    const getMonthName = (monthNumber) => {
        const monthNames = [
            "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
            "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
        ];
        return monthNames[monthNumber];
    };


    function removeFirstTwoNumbersAfterDash(input) {
        // Split the input string into two parts at the first '-'
        const [prefix, suffix] = input.split('-');

        // Remove the first two numbers from the suffix
        const modifiedSuffix = suffix.replace(/^\d{2}/, '');

        // Recombine the prefix and modified suffix
        return `${prefix}-${modifiedSuffix}`;
    }

    // Example usage
    // const result = removeFirstTwoNumbersAfterDash('DCE-241');
    // console.log(result);  // Output: 'DCE-1'



    useImperativeHandle(ref, () => ({ handleDownload }));

    return null;
});

export default ApplicationForm;
